import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByKey',
  standalone: true
})
export class SortByKeyPipe implements PipeTransform {
  transform(value: any[], key: string, ascending: boolean = true): any[] {
    if (!Array.isArray(value) || !key) {
      return value;
    }

    const sortedArray = [...value];
    return sortedArray.sort((a, b) => {
      const keyA = a[key];
      const keyB = b[key];

      if (keyA < keyB) return ascending ? -1 : 1;
      if (keyA > keyB) return ascending ? 1 : -1;
      return 0;
    });
  }
}
